goog.provide('el8.appanalytics.dialog.patientListCSV');

goog.require('el8.template.appanalytics.dialog.downloadCSV');
goog.require('el8.uiwidget.NewDialog');

// Patient list CSV download dialog
//
// On .show() it does a pseudo-longpoll using our conventions. First doing a POST of the
// query. If the POST returned a asyncTaskId, it will continue to poll with GETs with
// that id until the results are returned (in this case a csv_id used to construct a download URL)
el8.appanalytics.dialog.patientListCSV = (function() {

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'close', 'Dismiss', function() {
            that.hide();
            that._contentElt.html(el8.template.appanalytics.dialog.downloadCSV.content({'name': 'patient list'}));
        }, false
    );

    var that = new el8.uiwidget.NewDialog({
        title: 'Download Patient List Results as CSV',
        modal: true,
        contentFn: function () {
            return el8.template.appanalytics.dialog.downloadCSV.content({'name': 'patient list'});
        },
        showXButton: false,
        height: 200,
        width: 520,
        buttonSet: buttonSet
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    that._bindTriggers = function() {
        that.getContentElt().on('click', '.download-trigger',  function(e) {
            var url = $(this).attr('data-url');
            if (url) { window.open(url); }
        });
    };

    var super_show = that.show;
    that.show = function(physicianId, query, filterText) {
        // Note: many results may come back before the initial 10s
        // interval and we'd like to have a nicer UX for them if possible
        super_show.call(that);

        var successCb = function (data) {
            var url = el8.service.urls.get('muPopulationCSVDownload', [data['csv_id']]);
            that._contentElt.html(el8.template.appanalytics.dialog.downloadCSV.done(
                {
                    'url': url,
                    'name': 'patient list'
                }
            ));
        };

        $.el8_longPoll({
            url: el8.service.urls.get('muPopulationCSV', [el8Globals.PRACTICE_ID]),
            data: JSON.stringify({"physician_id": physicianId || null, "query": query, "filter_text": filterText || null}),
            success: successCb,
            error: function(data) {
                el8.appservice.notifier.clear();
                el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
            }
        });
    };

    return that;

})();
